import type { DashboardWidgetId } from './widgetCatalogue'

export type AirportCodes = string[]

export type WidgetOptionValue = boolean

export interface WidgetSettings {
    airports: AirportCodes
    options: Record<string, WidgetOptionValue>
}

export interface DashboardTabSettings {
    id: string
    airports: AirportCodes
    widgets: DashboardWidgetId[]
}

export type RunwayLayoutMode = 'arrival' | 'departure' | 'conditional'

export interface RunwayPoint {
    x: number
    y: number
}

export interface RunwayLayoutRunway {
    ends: [string, string]
    from: RunwayPoint
    to: RunwayPoint
    width: number
    outline?: string
}

export const RUNWAY_TONES = ['default', 'silver', 'blue', 'indigo'] as const

export type RunwayTone = (typeof RUNWAY_TONES)[number]

export interface RunwayPalette {
    runway?: RunwayTone
    departure?: RunwayTone
}

export interface RunwayLayout {
    modes: RunwayLayoutMode[]
    labelDistance?: number
    arrowsAlongRunway?: boolean
    palette?: RunwayPalette
    runways: RunwayLayoutRunway[]
}

export interface StatusDashboardSettings {
    allowAdminDismissWarning: boolean
    widgets: Partial<Record<DashboardWidgetId, WidgetSettings>>
    tabs?: DashboardTabSettings[]
    overviewOrder?: DashboardWidgetId[]
    runwayLayouts?: Record<string, RunwayLayout>
}

export interface ResolvedWidget {
    enabled: boolean
    options: Record<string, WidgetOptionValue>
}
